import React, { FC, Fragment, useState } from 'react';
import { Box, Grid, Paper } from '@mui/material';
import OrderInvoiceFilter from 'components/manage-collective-invoices/order-invoice-filter/order-invoice-filter.component';
import ManageCollectiveInvoices from 'components/manage-collective-invoices/manage-collective-invoices/manage-collective-invoices.component';
import { selectedClinicsVar } from 'apollo/reactive-variables/invoice';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

type CreateCollectiveInvoiceProps = {
    handleNext: () => void;
};

const CreateCollectiveInvoice: FC<CreateCollectiveInvoiceProps> = ({ handleNext }: CreateCollectiveInvoiceProps) => {
    const { t: translate } = useTranslation(['orders']);
    const [clinicsLength, setClinicsLength] = useState(Object.keys(selectedClinicsVar()).length);
    const updateClinicsLength = (length: number) => {
        setClinicsLength(length);
    };
    return (
        <Fragment>
            <Helmet>
                <title>{translate('orders:CREATE_COLLECTIVE_INVOICES')} | Denthub</title>
            </Helmet>
            <Paper>
                <Box p={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={9}>
                            <ManageCollectiveInvoices updateClinicsLength={updateClinicsLength} />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <OrderInvoiceFilter clinicsLength={clinicsLength} handleNext={handleNext} />
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
        </Fragment>
    );
};

export default CreateCollectiveInvoice;
